import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@urc-ui/store/types';
import { DEFAULT_PAGE_SIZE } from '@urc-ui/store/constants';

interface ReportsDataTableState {
  readonly pageSize: number;
}

const initialState: ReportsDataTableState = {
  pageSize: DEFAULT_PAGE_SIZE
};

/**
 * `createSlice` will infer the state type from the `initialState` argument
 */
export const reportsDataTableSlice = createSlice({
  name: 'reportsDataTableSlice',
  initialState,
  reducers: {
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    }
  }
});

export const { setPageSize } = reportsDataTableSlice.actions;

// selectors
export const selectPageSize = (state: RootState) => state.reportsDataTable.pageSize;

export default reportsDataTableSlice.reducer;
